import { ButtonMenu } from '@solinkcorp/solink-components';
import React from 'react';
import './UserDropDownMenu.sass';

export interface MenuItem {
  icon?: React.ReactNode;
  id?: string;
  onClick?: () => void;
  text?: string;
  type: 'action' | 'label' | 'divider';
  className?: string;
  isVisible?: boolean;
  /** Solink-internal-only action (Aspen profile menu: divider + accent icons). */
  isInternal?: boolean;
}

interface UserDropDownMenuProps {
  className?: string;
  menuClassName?: string;
  menuItems: readonly MenuItem[];
  userName?: string;
  userEmail: string;
  isImpersonating: boolean;
}

const UserDropDownMenu: React.FC<UserDropDownMenuProps> = ({
  className = '',
  menuClassName = '',
  menuItems,
  userName,
  userEmail,
  isImpersonating,
}) => {
  const firstLetter = (userName ?? userEmail).charAt(0)?.toUpperCase();

  return (
    <div className={`user-dropdown-menu ${className}`} data-testid="desk-nav-user-settings">
      <ButtonMenu
        label={firstLetter}
        buttonTypography="uppercase"
        buttonColorMode="dark"
        buttonType="clear"
        colorMode="dark"
        dataTestId="user-settings"
        menuItems={menuItems}
        menuRootClass={`user-dropdown-popup-menu ${menuClassName}`}
        menuStyle={{ minWidth: '190px' }}
        id="user-menu-button"
        buttonClass={isImpersonating ? 'impersonating' : ''}
        tooltipVerticalOffset={3}
        showPointer={false}
      />
    </div>
  );
};

export default UserDropDownMenu;
